import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-editpopup',
  templateUrl: './editpopup.component.html',
  styleUrls: ['./editpopup.component.scss']
})
export class EditpopupComponent implements OnInit {
  isDivVisible:string='hidden';
  constructor(    public dialogRef: MatDialogRef<EditpopupComponent>) { }
  ngOnInit(): void {
  }
  profileForm = new FormGroup({
    PersonID: new FormControl(''),
    ChildFirstName: new FormControl(''),
    ChildLastName: new FormControl(''),
    // BeginDate:new FormControl(''),
    // EndDate:new FormControl(''),
    MotherFirstName: new FormControl(''),
    MotherLastName: new FormControl(''),
    // MotherBeginDate:new FormControl(''),
    // MotherEndDate:new FormControl(''),
    // BirthFacility:new FormControl('')
  });
  onClose() {
    this.dialogRef.close();
}

}
